module.exports = __webpack_public_path__ + "static/media/settingsActive.cae6d8ba.svg";